// extracted by mini-css-extract-plugin
export default {"templatesGrid":"OFg2SO"};